export const FETCH_MERCHANT_PAGE_CONTENT = 'GIFTYA/FETCH_MERCHANT_PAGE_CONTENT';
export const FETCH_MERCHANT_PAGE_CONTENT_SUCCESS = 'GIFTYA/FETCH_MERCHANT_PAGE_CONTENT_SUCCESS';
export const FETCH_MERCHANT_PAGE_CONTENT_FAILURE = 'GIFTYA/FETCH_MERCHANT_PAGE_CONTENT_FAILURE';
export const FETCH_YELP_IMAGES_FOR_MERCHANTS = 'GIFTYA/FETCH_YELP_IMAGES_FOR_MERCHANTS';
export const FETCH_YELP_IMAGES_FOR_MERCHANTS_RESET = 'GIFTYA/FETCH_YELP_IMAGES_FOR_MERCHANTS_RESET';
export const UPLOAD_YELP_IMAGE_TO_S3 = 'GIFTYA/UPLOAD_YELP_IMAGE_TO_S3';
export const RESET_UPLOAD_YELP_IMAGE_TO_S3 = 'GIFTYA/RESET_UPLOAD_YELP_IMAGE_TO_S3';
export const SET_MERCHANT_CONTENT = 'GIFTYA/SET_MERCHANT_CONTENT';
export const IS_YELP_IMAGE_OK = 'GIFTYA/IS_YELP_IMAGE_OK';
export const IS_YELP_IMAGE_OK_RESET = 'GIFTYA/IS_YELP_IMAGE_OK_RESET';
export const GET_MERCHANT_ONBOARDING_CONTENT = 'GIFTYA/GET_MERCHANT_ONBOARDING_CONTENT';
export const GET_MERCHANT_ONBOARDING_CONTENT_RESET = 'GIFTYA/GET_MERCHANT_ONBOARDING_CONTENT_RESET';
export const POST_MERCHANT_ONBOARDING_PARTNER_FORM = 'GIFTYA/POST_MERCHANT_ONBOARDING_PARTNER_FORM';
export const POST_MERCHANT_ONBOARDING_PARTNER_FORM_RESET = 'GIFTYA/POST_MERCHANT_ONBOARDING_PARTNER_FORM_RESET';
export const GET_MERCHANT_DEAL_LOCATIONS = 'GIFTYA/GET_MERCHANT_DEAL_LOCATIONS';
export const GET_MERCHANT_DEAL_LOCATIONS_RESET = 'GIFTYA/GET_MERCHANT_DEAL_LOCATIONS_RESET';
export const GET_MERCHANT_DEALS_BY_LOCATION = 'GIFTYA/GET_MERCHANT_DEALS_BY_LOCATION';
export const GET_MERCHANT_DEALS_BY_LOCATION_RESET = 'GIFTYA/GET_MERCHANT_DEALS_BY_LOCATION_RESET';
export const REDEEM_MERCHANT_DEAL = 'GIFTYA/REDEEM_MERCHANT_DEAL';
export const REDEEM_MERCHANT_DEAL_RESET = 'GIFTYA/REDEEM_MERCHANT_DEAL_RESET';
export const GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT = 'GIFTYA/GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT';
export const GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT_RESET = 'GIFTYA/GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT_RESET';

export const getAccessDevelopmentMerchantCount = (payload, meta = {}, error = false) => ({
    type: GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT,
    payload,
    meta,
    error
});
export const getAccessDevelopmentMerchantCountReset = (payload, meta = {}, error = false) => ({
    type: GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT_RESET,
    payload,
    meta,
    error
});
export const redeemMerchantDeal = (payload, meta = {}, error = false) => ({
    type: REDEEM_MERCHANT_DEAL,
    payload,
    meta,
    error
});
export const redeemMerchantDealReset = (payload, meta = {}, error = false) => ({
    type: REDEEM_MERCHANT_DEAL_RESET,
    payload,
    meta,
    error
});
export const getMerchantDealsByLocation = (payload, meta = {}, error = false) => ({
    type: GET_MERCHANT_DEALS_BY_LOCATION,
    payload,
    meta,
    error
});
export const getMerchantDealsByLocationReset = (payload, meta = {}, error = false) => ({
    type: GET_MERCHANT_DEALS_BY_LOCATION_RESET,
    payload,
    meta,
    error
});
export const getMerchantDealLocations = (payload, meta = {}, error = false) => ({
    type: GET_MERCHANT_DEAL_LOCATIONS,
    payload,
    meta,
    error
});
export const getMerchantDealLocationsReset = (payload, meta = {}, error = false) => ({
    type: GET_MERCHANT_DEAL_LOCATIONS_RESET,
    payload,
    meta,
    error
});
export const isYelpImageOk = (payload, meta = {}, error = false) => ({
    type: IS_YELP_IMAGE_OK,
    payload,
    meta,
    error
});
export const isYelpImageOkReset = (payload, meta = {}, error = false) => ({
    type: IS_YELP_IMAGE_OK_RESET,
    payload,
    meta,
    error
});

export const fetchMerchantPageContent = (data) => ({
    type: FETCH_MERCHANT_PAGE_CONTENT,
    data
});

export const setMerchantContent = (data) => ({
    type: SET_MERCHANT_CONTENT,
    data
});
export const fetchMerchantPageContentSuccess = (data) => ({
    type: FETCH_MERCHANT_PAGE_CONTENT_SUCCESS,
    data
});
export const fetchMerchantPageContentFailure = () => ({
    type: FETCH_MERCHANT_PAGE_CONTENT_FAILURE
});

export const fetchYelpImagesForMerchants = (payload, meta = {}, error = false) => ({
    type: FETCH_YELP_IMAGES_FOR_MERCHANTS,
    payload,
    meta,
    error
});

export const fetchYelpImagesForMerchantsReset = (payload, meta = {}, error = false) => ({
    type: FETCH_YELP_IMAGES_FOR_MERCHANTS_RESET,
    payload,
    meta,
    error
});

export const uploadYelpImageToS3 = (payload, meta, error) => ({
    type: UPLOAD_YELP_IMAGE_TO_S3,
    payload,
    meta,
    error
});
export const resetUploadYelpImageToS3 = (payload, meta, error) => ({
    type: RESET_UPLOAD_YELP_IMAGE_TO_S3,
    payload,
    meta,
    error
});

export const getMerchantOnboardingContent = (payload, meta, error) => ({
    type: GET_MERCHANT_ONBOARDING_CONTENT,
    payload,
    meta,
    error
});

export const getMerchantOnboardingContentReset = (payload, meta, error) => ({
    type: GET_MERCHANT_ONBOARDING_CONTENT_RESET,
    payload,
    meta,
    error
});

export const postMerchantOnboardingPartnerForm = (payload, meta, error) => ({
    type: POST_MERCHANT_ONBOARDING_PARTNER_FORM,
    payload,
    meta,
    error
});

export const postMerchantOnboardingPartnerFormReset = (payload, meta, error) => ({
    type: POST_MERCHANT_ONBOARDING_PARTNER_FORM_RESET,
    payload,
    meta,
    error
});